/**
*@title 일정 안내
*@date 2022-02-09
*@author 홍수희
*@desc
*@etc(change)
*/

import React from 'react';
import Slider from "react-slick";
import { t } from 'i18next';

import { AiFillCaretLeft, AiFillCaretRight} from "react-icons/ai";

import "../../Components/Slider/slick.css";
import "../../Components/Slider/slick-poster-theme.css";

import poster1 from '../../images_poster/poster_2022.png'
import poster2 from '../../images_poster/poster_2022_2.png'
import poster3 from '../../images_poster/poster_2022_3.png'
import poster4 from '../../images_poster/poster_2022_4.png'
import poster5 from '../../images_poster/poster_2022_5.png'

import "animate.css/animate.min.css";
import { AnimationOnScroll } from 'react-animation-on-scroll';


const GalleryPoster = () => {
    let slidesToShow = Math.floor(window.innerWidth/500)
    if(slidesToShow === 0){
        slidesToShow = 1
    }
    const settings = {
        arrows:false,
        dots: true,
        infinite: true,
        speed: 500,
        // centerMode : true,
        // nextArrow: <ArrowRight />,
        // prevArrow: <ArrowLeft />,
        slidesToShow:slidesToShow,
        slidesToScroll:1
    };
    
    return(
        <div className="sect-01-box-01-gallery margin-top-100 margin-btm-100">
            <div className="sect-03-tit-01 sect-tit">{t("gallery_poster_title")}</div>
            <div className='gallery-poster-wrap'>
                <Slider {...settings}>
                    <div className='gallery-poster-image-box'>
                        <img src = {poster1}></img>
                    </div>
                    <div className='gallery-poster-image-box'>
                        <img src = {poster2}></img>
                    </div>
                    <div className='gallery-poster-image-box'>
                        <img src = {poster3}></img>
                    </div>
                    <div className='gallery-poster-image-box'>
                        <img src = {poster4}></img>
                    </div>
                    <div className='gallery-poster-image-box'>
                        <img src = {poster5}></img>
                    </div>
                </Slider>
            </div>
        </div>
    )
}

export default GalleryPoster;